import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { frontendDb as db } from '../lib/frontend-db';

interface WiesenFooterSettings {
  backgroundColor: string;
  textColor: string;
  linkColor: string;
  linkHoverColor: string;
}

const WiesenFooter = () => {
  const [footerSettings, setFooterSettings] = useState<WiesenFooterSettings>({
    backgroundColor: '#2d5a2f',
    textColor: '#ffffff',
    linkColor: '#ffffff',
    linkHoverColor: 'rgba(255, 255, 255, 0.8)'
  });

  useEffect(() => {
    loadFooterSettings();
  }, []);

  const loadFooterSettings = async () => {
    try {
      const settings = await db.getSettings();
      if (settings) {
        const wiesenFooterSettings = {
          backgroundColor: (settings as any).wiesen_footer_bg_color || footerSettings.backgroundColor,
          textColor: (settings as any).wiesen_footer_text_color || footerSettings.textColor,
          linkColor: (settings as any).wiesen_footer_link_color || footerSettings.linkColor,
          linkHoverColor: (settings as any).wiesen_footer_link_hover_color || footerSettings.linkHoverColor,
        };
        setFooterSettings(wiesenFooterSettings);
      }
    } catch (error) {
      console.error('Error loading Wiesen footer settings:', error);
    }
  };

  return (
    <footer 
      className="py-8 transition-colors duration-300"
      style={{ backgroundColor: footerSettings.backgroundColor }}
    >
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <p 
            className="text-center md:text-left mb-4 md:mb-0"
            style={{ color: footerSettings.textColor }}
          >
            Liederkranz Wiesen e.V. © Copyright {new Date().getFullYear()}
          </p>
          <div className="flex space-x-4">
            <Link 
              to="/wiesen-info/impressum" 
              className="transition-colors duration-200"
              style={{ 
                color: footerSettings.linkColor,
                '--hover-color': footerSettings.linkHoverColor
              } as React.CSSProperties}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = footerSettings.linkHoverColor;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = footerSettings.linkColor;
              }}
            >
              Impressum
            </Link>
            <Link 
              to="/wiesen-info/datenschutz" 
              className="transition-colors duration-200"
              style={{ 
                color: footerSettings.linkColor,
                '--hover-color': footerSettings.linkHoverColor
              } as React.CSSProperties}
              onMouseEnter={(e) => {
                e.currentTarget.style.color = footerSettings.linkHoverColor;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.color = footerSettings.linkColor;
              }}
            >
              Datenschutz
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default WiesenFooter;

